<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                    <el-button v-if="permission.print && tableData.length > 0" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                        permission.print
                    }}</el-button>
                    <el-button
                        v-if="permission.exportExcel && tableData.length > 0"
                        size="small"
                        icon="fa fa-file-excel-o"
                        class="search-btn btn-primary"
                        @click="exportExcel()"
                        >导出Excel</el-button
                    >
                    <el-button v-if="permission.batchComfirm" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()"
                        >{{ permission.batchComfirm }} (F3)</el-button
                    >
                    <el-button v-if="permission.scanConfirm" size="small" type="warning" class="search-btn" @click="scanComfirms()"
                        >{{ permission.scanConfirm }} (F4)</el-button
                    >
                    <div v-if="permission.scanConfirm" class="search-name" style="color: red">
                        （使用扫码确认功能请确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）
                    </div>
                </div>
                <div class="search-ctn-right" v-if="totalSummaryStr">
                    <div class="section-summary">
                        <div>
                            <span>{{ totalSummaryStr ? '合计：' + totalSummaryStr : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="500"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    :tableCode="tableCode"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <template v-for="(col, index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <img
                                    src="@/assets/images/union.png"
                                    title="联盟订单"
                                    style="width: 20px; height: 20px; margin-right: 3px"
                                    v-if="scope.row.IsUnionOrder"
                                />
                                <img src="@/assets/images/agent.png" title="联盟代发单（联盟发）" style="width: 20px; height: 20px" v-if="scope.row.IsMyAgentOrder" />
                                <img src="@/assets/images/cusagent.png" title="联盟代发单(我发)" style="width: 20px; height: 20px" v-if="scope.row.IsCusAgentOrder" />
                                <img src="@/assets/images/chong.png" title="需要冲减" style="width: 20px; height: 20px; margin-right: 3px" v-if="scope.row.IsDeduct" />
                                {{ scope.row.OrderCode }}
                                <img
                                    v-show="scope.row.OrderId"
                                    src="@/assets/images/preview.png"
                                    title="打印预览"
                                    style="margin-left: 5px; width: 24px; height: 24px"
                                    @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId)"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OutWarehouseStateName'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsAllNotOut" class="out-active">不需出仓</i>
                                <i v-else-if="scope.row.IsDelivery" class="out-active">已出仓</i>
                                <i v-else>未出仓</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderType'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                                <i v-else class="out-active">销售退货</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'ConfirmStateName'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsCanStateBack" class="confirm-active">{{ scope.row.ConfirmStateName }}</i>
                                <i v-else>{{ scope.row.ConfirmStateName }}</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderAmount'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.OrderAmount : -scope.row.OrderAmount }}</template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'BillAmount'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.OrderType == 0 ? scope.row.BillAmount.toFixed(2) : '' }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderCost'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.OrderCost == 0 && !scope.row.IsAllNotOut" class="cost-error">{{
                                    (scope.row.OrderType == 0 ? scope.row.OrderCost : -scope.row.OrderCost).toFixed(2)
                                }}</i>
                                <i v-else> {{ (scope.row.OrderType == 0 ? scope.row.OrderCost : -scope.row.OrderCost).toFixed(2) }}</i>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'OrderCost'"
                        >
                            <template slot="header">
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">
                                        标签或手动出入仓总成本
                                    </div>
                                    <span>
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                </el-tooltip>
                                配件成本
                            </template>
                            <template slot-scope="scope">
                                <el-button  @click.stop="showLabelsData(scope.row)" type="text" style="padding: 0px">
                                     <i :class="scope.row.OrderCost == 0 && !scope.row.IsAllNotOut ? 'cost-error' : ''">
                                        {{ (scope.row.OrderType == 0 ? scope.row.OrderCost : -scope.row.OrderCost).toFixed(2) }}
                                     </i>
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderProfit'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{
                                    (scope.row.OrderType == 0 ? scope.row.SurplusMoney - scope.row.OrderCost : -(scope.row.SurplusMoney - scope.row.OrderCost)).toFixed(2)
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'CalcAmount'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{
                                    scope.row.OrderType == 0
                                        ? (scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount).toFixed(2)
                                        : -(scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount).toFixed(2)
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="flex">
                                <el-button
                                    v-if="permission.confirm && !scope.row.IsCanStateBack && (scope.row.IsDelivery || scope.row.IsAllNotOut)"
                                    :title="permission.confirm"
                                    size="mini"
                                    type="text"
                                    @click.stop="confirm(scope.row)"
                                    >{{ permission.confirm }}</el-button
                                >
                                <el-button
                                    v-if="permission.stateBack && scope.row.IsCanStateBack && !scope.row.IsLock"
                                    :title="permission.stateBack"
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    @click.stop="stateBack(scope.row)"
                                    >{{ permission.stateBack }}</el-button
                                >
                                <el-button
                                    v-if="
                                        permission.correctCost &&scope.row.IsDelivery&&
                                            scope.row.IsHaveCostZero &&
                                            !scope.row.IsCanStateBack &&
                                            !scope.row.IsAllNotOut
                                    "
                                    :title="permission.correctCost"
                                    size="mini"
                                    type="text"
                                    style="color: orange"
                                    @click.stop="correctCost(scope.row)"
                                    >{{ permission.correctCost }}</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="section-summary" v-if="isShowSummary">
                    <div>
                        <span>合计：{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}订单明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="loading"
                    class="detail-table"
                    :data="orderGoodsData"
                    style="width: 100%"
                    height="200px"
                    border=""
                    :header-cell-style="{ background: '#F2F6FC' }"
                >
                    <el-table-column prop="SortNum" label="序号" width="80"></el-table-column>
                    <el-table-column prop="APCode" label="汽配编码" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodName" label="汽配名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="AutoSerise" label="车型" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Origin" label="产地" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Count" label="数量" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Count : -scope.row.Count }}</template>
                    </el-table-column>
                    <el-table-column prop="Unit" label="单位" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Price" label="销售价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Price.toFixed(2) : -scope.row.Price.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="Price" label="开单价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.BillingPrice.toFixed(2) : '' }}</template>
                    </el-table-column>
                    <el-table-column prop="PriceAmount" label="销售总价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.OrderType == 0 ? (scope.row.Count * scope.row.Price).toFixed(2) : -(scope.row.Count * scope.row.Price).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="WarehousedCount" label="已出库数" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.WarehousedCount : -scope.row.WarehousedCount }}</template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="出库单搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="客户">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="客户名称/电话"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="部门" v-if="isExObj('OrgName')">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData.OrgIds"
                                filterable
                                clearable
                                collapse-tags
                                reserve-keyword
                                multiple
                                @visible-change="orgVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="optionItem in orgSearchData"
                                    :key="optionItem.Id"
                                    :data-msg="optionItem"
                                    :label="optionItem.Name"
                                    :value="optionItem.Id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号" v-if="isExObj('OrderCode')">
                            <el-input
                                ref="search_1"
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="销售/退货单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="出库仓库" v-if="isExObj('WarehouseName')">
                            <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                                <el-option
                                    v-for="optionItem in warehouseList"
                                    :key="optionItem.WarehouseId"
                                    :label="optionItem.WarehouseName"
                                    :value="optionItem.WarehouseId"
                                >
                                    <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                    <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支付方式" v-if="isExObj('PayTypeName')">
                            <el-select ref="search_2" class="search-item" style="width: 100%" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流公司" v-if="isExObj('LogistName')">
                            <el-select
                                ref="search_3"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.LogisName"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="请输入物流名称"
                                @visible-change="lcsVisibleChange($event)"
                                :remote-method="searchlcs"
                                v-select-scroll-more="searchLcsLoad"
                                @change="lcsChange"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in lcsList" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流状态" v-if="isExObj('OutWarehouseStateName')">
                            <el-select ref="search_3_1" class="search-item" style="width: 100%" size="small" v-model="searchData.DeliveryState">
                                <el-option v-for="item in deliStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认状态" v-if="isExObj('ConfirmStateName')">
                            <el-select ref="search_4" class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据类型" v-if="isExObj('OrderType')">
                            <el-select ref="search_5" class="search-item" style="width: 100%" size="small" v-model="searchData.OrderType">
                                <el-option v-for="item in orderTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务员" v-if="isExObj('SName')">
                            <el-select
                                ref="search_6"
                                key="SId"
                                v-model="searchData.SId"
                                style="width: 100%"
                                class="search-item"
                                size="small"
                                filterable
                                clearable
                                placeholder="请选择"
                            >
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认人" v-if="isExObj('Confirmer')">
                            <el-select
                                ref="search_7"
                                v-model="searchData.ConfirmerId"
                                style="width: 100%"
                                class="search-item"
                                size="small"
                                filterable
                                clearable
                                placeholder="请选择"
                                key="ConfirmerId"
                            >
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                            <el-date-picker
                                ref="search_8"
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期" v-if="isExObj('ConfirmTime')">
                            <el-date-picker
                                ref="search_9"
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交日期" v-if="isExObj('SubmitTime')">
                            <el-date-picker
                                ref="search_10"
                                size="small"
                                style="width: 100%"
                                v-model="datetime3"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate3TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="出库日期" v-if="isExObj('WHFinishTime')">
                            <el-date-picker
                                ref="search_11"
                                size="small"
                                style="width: 100%"
                                v-model="datetime4"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate4TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="查询公式">
                            <el-radio-group v-model="searchData.SearchType">
                                <el-radio :label="0">左等</el-radio>
                                <el-radio :label="1">全等</el-radio>
                                <el-radio :label="2">包含</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="扫码确认"
                :visible.sync="dialogScanVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogScanVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="单号">
                            <el-input
                                class="search-name"
                                ref="inputdata"
                                v-model="scanData"
                                clearable
                                placeholder="请扫描销售单或退货单二维码"
                                size="small"
                                style="width: 250px"
                                @change="inputDataChange()"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="确认单据" :visible.sync="confirmVisible" width="1000px">
                <div class="dialog-content" v-if="confirmVisible">
                    <ConfirmReceipt ref="confirmReceipt" @closeConfirm="closeConfirm(arguments)" :confirmData="currentRow" :type="0"></ConfirmReceipt>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="批量确认"
                :visible.sync="dialogBacthVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogBacthVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="支付方式" prop="PayType">
                            <el-select ref="confirm_0" class="search-item" style="width: 100%" size="small" v-model="confirmFormData.PayType">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流公司" prop="LogisticId">
                            <el-select
                                style="width: 100%"
                                v-model="confirmFormData.LogisticId"
                                value-key="EntpCusId"
                                placeholder="请输入物流公司"
                                size="small"
                                filterable
                                clearable
                                default-first-option
                                remote
                                reserve-keyword
                                :remote-method="searchLogistic"
                                @visible-change="logisticVisibleChange($event)"
                                v-select-scroll-more="searchLcLoad"
                                @change="logisticChange"
                            >
                                <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item.EntpCusId">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span class="phone" v-if="item.Phone">
                                            {{ ' ( 电话：' + item.Phone + ' )' }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button size="small" @click="closeBacthConfirm()">关闭（Esc）</el-button>
                        <el-button class="btn-primary" size="small" @click="handleBacthSubmit">提交（Enter）</el-button>
                    </div>
                </div>
            </el-dialog>
            <!--  打印  -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printDeliveryConfirms @closeDialog="closePrintDialog" :sParams="searchParams" :isInit="true"></printDeliveryConfirms>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
                <div class="dialog-content" v-if="printOrderPreview">
                    <printContentDC @closeDialog="closeOrderPrintDialog" :printIds="idList" :showDisc="showDisc" :isInit="true"></printContentDC>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
                <div class="dialog-content" v-if="printReturnPreview">
                    <printReturnContentDC @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContentDC>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="校准成本价" :visible.sync="correctVisible" width="1000px">
                <div class="dialog-content" v-if="correctVisible">
                    <CorrectCostPrice ref="correctCostPrice" @closeCorrectDialog="closeCorrectDialog(arguments)" :correctData="correctItem"></CorrectCostPrice>
                </div>
            </el-dialog>
            <el-dialog
                title="标签数据"
                :close-on-click-modal="false"
                :visible.sync="labelVisible"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="label-dialog"
                style="margin-left: -500px"
                width="1000px"
            >
                <div v-if="labelVisible">
                    <orderGoodsLabels ref="orderGoodsLabels" :recData="recData" @closeDialog="labelVisible = false"></orderGoodsLabels>
                </div>
            </el-dialog>
            <audio ref="audio" controls hidden></audio>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ConfirmReceipt from '@/components/business/revenue_h/confirmOutOrder';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import CorrectCostPrice from '@/components/business/revenue_h/correctCostPrice';
import orderGoodsLabels from '@/components/business/goodsLables/orderGoodsLabels';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ConfirmReceipt,
        CorrectCostPrice,
        orderGoodsLabels
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        tableData() {
            this.doLayout();
        }
    },
    data() {
        return {
            correctItem: {},
            correctVisible: false,
            searchIndex: 0,
            isStartSearch: false,
            summaryStr: '',
            totalSummaryStr: '',
            orderCode: '',
            datetime1: [],
            datetime2: [],
            datetime3: [],
            datetime4: [],
            orgSearchData: [],
            loading: '',
            tableCode: 'DeliveryConfirms_H',
            multipleSelection: null,
            dialogVisible: false,
            dialogScanVisible: false,
            firstScanOrder: true,
            confirmVisible: false,
            dialogBacthVisible: false,
            scanData: '',
            dataindex: -1,
            stopFresh: false,
            stopRequest: false,
            stopConfirm: false,
            isShowSummary: false,
            searchData: {
                State: '',
                SId: '',
                DeliveryState: '',
                PayType: [],
                Keyword: '',
                LogisName: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                CusId: '',
                WarehouseId: '',
                OrgIds: [],
                SearchType: 2,
                page: 1,
                limit: this.commonPageSize
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未确认', Value: '0' },
                { Text: '已确认', Value: '1' }
            ],
            orderTypeList: [
                { Text: '全部', Value: '' },
                { Text: '销售单', Value: '0' },
                { Text: '销售退货单', Value: '1' }
            ],
            deliStateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '0' },
                { Text: '已出仓', Value: '1' },
                { Text: '不需出仓', Value: '2' }
            ],
            SIdList: [],
            payWayList: [],
            idList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printDialogVisible: false,
            printOrderPreview: false,
            printReturnPreview: false,
            askShowDisc: false,
            showDisc: false,
            isCostCheck: false,
            warehouseList: [],
            logisticsList: [],
            // 用于物流公司列表，分页搜索
            lcForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            //出库确认列表物流查询条件
            lcsList: [],
            lcsForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            confirmFormData: {
                OrderIds: [],
                PayType: '',
                LogisticId: '',
                LogisticName: ''
            },
            isDefaultSet: false,
            labelVisible: false,
            recData: '',
            checkRepeatCodeAudio: '/download/repeat.mp3',
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        let that = this;
        that.getSetsData().then(() => {
            //当前设定的日期时间
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);

            //前一天设定的日期时间
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date2 = new Date(year2, month2, day2, 0);

            if (that.isExObj('SubmitTime')) {
                that.datetime3.push(date1);
                that.datetime3.unshift(date2);

                that.searchData.CStartDate = date2;
                that.searchData.CEndDate = date1;
            } else if (that.isExObj('CreateTime')) {
                that.datetime1.push(date1);
                that.datetime1.unshift(date2);

                that.searchData.StartDate = date2;
                that.searchData.EndDate = date1;
            }
            that.getTableData();
            that.permission = this.$util.getPermission('DeliveryConfirms_H');
            that.getConfigByCodes().then(() => {
                that.initSearchSelectData();
                that.getPrintComponents();
            });
        });
    },
    mounted() {},
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            //F2
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            //F3
            if (key === 114) {
                that.batchComfirms();
            }
            //F4
            if (key === 115) {
                that.scanComfirms();
            }
            if (key === 13) {
                if (!that.dialogScanVisible) {
                    if (that.dialogBacthVisible) {
                        if (that.$refs.confirm_0) that.$refs.confirm_0.blur();
                        that.handleBacthSubmit();
                    } else {
                        if (that.dialogVisible) {
                            that.handleSearch();
                            that.isStartSearch = false;
                        } else if (!that.confirmVisible) {
                            if (that.currentRow && (that.currentRow.IsDelivery || that.currentRow.IsAllNotOut)) {
                                if (that.currentRow.OrderId && !that.currentRow.IsCanStateBack && !that.currentRow.IsCanStateBack) that.confirmVisible = true;
                            } else {
                                that.$util.warningMsg('订单还未出仓，请待出仓后再进行确认');
                                return;
                            }
                        } else if (that.confirmVisible) {
                            if (that.$refs.confirmReceipt) {
                                that.$refs.confirmReceipt.submitForm();
                            }
                        }
                    }
                }
            }
            //ESC
            if (key === 27) {
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                } else if (that.confirmVisible) that.confirmVisible = false;
                else if (that.dialogBacthVisible) that.dialogBacthVisible = false;
                else if (that.dialogScanVisible) that.dialogScanVisible = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableData.length - 1) {
                    if (that.currentRow && that.currentRow.OrderId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xwdyxxdxxyh', 'cwqrqzcb', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                    this.askShowDisc = result;
                                    break;
                                case 'cwqrqzcb': //财务确认强制成本为零的无法提交,用于提醒
                                    this.isCostCheck = result;
                                    break;
                                case 'syllqdysz': //是否使用浏览器打印
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        tableLoad() {
            if (!this.stopFresh && this.firstScanOrder && this.tableData && this.tableData.length > 0) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },

        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
            if (this.isCostCheck) if (row.IsHaveCostZero&& !row.IsCanStateBack && !row.IsAllNotOut) return 'row-warning';
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.getOrderDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '';
                if (item.OrderType == 0) url = '/api/EntpSaleOrder/GetOrderItemsById';
                else url = '/api/EntpSaleReturnOrder/GetEntpCusReturnOrderGoodsListById';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            OrderId: item.OrderId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderGoodsData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let sa = 0; //销售总额
                let sahj = 0; //合计
                let yh = 0;
                let yf = 0;
                let shhj = 0; //实收总合计
                for (let i = 0; i < val.length; i++) {
                    idList.push(val[i].OrderId);
                    let oa = val[i].OrderAmount;
                    let ss = val[i].Paid;
                    if (val[i].OrderType == 0) {
                        sa += oa;
                        sahj += val[i].OrderAmount + val[i].ShipAmount - val[i].DiscountAmount;
                        if (val[i].IsCanStateBack) shhj += ss;
                    } else {
                        sa -= oa;
                        sahj -= oa;
                        if (val[i].IsCanStateBack) shhj -= ss;
                    }
                    yh += val[i].DiscountAmount;
                    yf += val[i].ShipAmount;
                }

                this.summaryStr =
                    '销售总额 = ' +
                    sa.toFixed(2) +
                    '；  优惠总额 = ' +
                    yh.toFixed(2) +
                    '；  运费总额 = ' +
                    yf.toFixed(2) +
                    '；  总合计 = ' +
                    sahj.toFixed(2) +
                    '；  实收总金额 = ' +
                    shhj.toFixed(2);

                this.idList = idList;
            }
        },
        resetSearch() {
            this.searchData = {
                SId: '',
                State: '',
                DeliveryState: '',
                PayType: [],
                Keyword: '',
                OrderCode: '',
                LogisName: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                CusId: '',
                WarehouseId: '',
                OrgIds: [],
                SearchType:2,
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            this.datetime4 = [];
            // this.searchCustom(''); 这里重置时禁止请求客户列表数据，因为频繁扫码的时间会发生超时
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.stopRequest) {
                if (that.searchData.page == 1) {
                    that.searchParams = { ...that.searchData };
                    that.tableData = [];
                } else {
                    that.searchParams.page = that.searchData.page;
                }

                if (that.searchData.Keyword) that.searchData.CusId = '';
                that.stopFresh = true;
                that.stopRequest = true;
                that.$util
                    .axiosPost({
                        // url: '/api/RevenueManagement_H/GetCusOrdersConfirmList',
                        url: '/api/RevenueManagement_H/GetCusOrdersConfirmList_New',
                        data: that.searchParams
                    })
                    .then(res => {
                        let data = res.data;
                        if (res.errcode != 201) {
                            if (that.searchData.page == 1) {
                                that.tableData = [];
                                that.tableDataLength = 0;
                                that.totalSummaryStr = '共合计0 项； 订单总额：0.00';
                                that.searchParams.total = 0;
                                if (data && data.DataList.length > 0) that.getOtherData();
                            }
                            let list = [...that.tableData, ...data.DataList];
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            that.tableData = list;
                            that.stopFresh = data.DataList.length < that.searchData.limit;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.stopRequest = false;
                    });
            }
        },
        getOtherData() {
            let that = this;
            that.$util
                .axiosPost({
                    // url: '/api/RevenueManagement_H/GetCusOrdersConfirmOtherData',
                    url: '/api/RevenueManagement_H/GetCusOrdersConfirmOtherData_New',
                    data: that.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (that.searchData.page == 1) {
                            that.tableDataLength = data.Total;
                            that.totalSummaryStr = data.SummaryStr;
                            that.searchParams.total = data.Total;
                        }
                    }
                })
                .catch(() => {});
        },
        handleSearch() {
            let that = this;
            that.dataindex = 0;
            that.firstScanOrder = true;
            that.idList = [];
            if (that.$refs.multipleTable) that.$refs.multipleTable.clearSelection();
            that.searchData.page = 1;
            that.getTableData();
        },
        stateBack(item) {
            let that = this;
            if (!that.dialogScanVisible) {
                if (item.OrderId) {
                    that.$confirm('您确定要将该确认状态回退到未确认状态吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            //预留批量回退的功能，但目前的业务可能不做
                            let ids = [];
                            ids.push(item.OrderId);
                            that.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_H/SaleConfirmStateBack',
                                    data: {
                                        OrderIds: ids
                                    }
                                })
                                .then(res => {
                                    that.$util.successMsg('状态回退成功');
                                    that.tableData.forEach(item => {
                                        that.$refs.multipleTable.toggleRowSelection(item, false);
                                        var index = ids.findIndex(f => f === item.OrderId);
                                        if (index > -1) {
                                            item.IsCanStateBack = false;
                                            item.ConfirmStateName = '未确认';
                                        }
                                    });
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                } else {
                    that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                }
            } else {
                that.$util.warningMsg('请先关闭扫码窗口');
            }
        },
        confirm(item) {
            let that = this;
            if (item.IsDelivery || item.IsAllNotOut) {
                if (!that.dialogScanVisible) {
                    if (item.OrderId) {
                        this.currentRow = item;
                        this.confirmVisible = true;
                    } else {
                        that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                    }
                } else {
                    that.$util.warningMsg('请先关闭扫码窗口');
                }
            } else {
                that.$util.warningMsg('订单还未出仓，请待出仓后再进行确认');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.idList.length > 0) {
                that.dialogBacthVisible = true;
                that.dialogScanVisible = false;
            } else {
                that.$util.warningMsg('请先勾选订单再进行批量确认操作');
            }
        },
        confirmOrder(ids) {
            let that = this;
            if(!(ids && ids.length > 0)){
                 that.$util.warningMsg('没有可确认的订单或者订单未完成出仓');
                 return;
            }
            if (!that.stopConfirm) {
                that.stopConfirm = true;
                that.confirmFormData.OrderIds = ids;
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/ConfirmSaleOrders',
                        data: that.confirmFormData
                    })
                    .then(res => {
                        that.firstScanOrder = true;
                        that.$util.successMsg('单据确认成功');
                        that.tableData.forEach(item => {
                            that.$refs.multipleTable.toggleRowSelection(item, false);
                            var index = ids.findIndex(f => f === item.OrderId);
                            if (index > -1) {
                                item.IsCanStateBack = true;
                                item.ConfirmStateName = '已确认';
                                item.PayTypeName = that.payWayList[that.payWayList.findIndex(f => f.Value === that.confirmFormData.PayType)].Text;
                                item.Confirmer = that.$util.getLocalStorage('userMsg').EmployeeName;
                                item.ConfirmTime = that.$util.formatDate(new Date().getTime());
                            }
                        });
                        that.idList = [];
                        that.firstScanOrder = true;
                        that.closeBacthConfirm();
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.stopConfirm = false;
                    });
            } else that.$util.warningMsg('请勿重新提交');
            
        },
        getSetsData() {
            let that = this;
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);

                            resolve();
                        });
                    })
                    .catch(res => {
                        resolve(res);
                    });
            });
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        sortChange(event) {
            if (event.order) this.searchData.SortProp = event.prop;
            else this.searchData.SortProp = '';
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        scanComfirms() {
            this.dialogScanVisible = true;
            this.inputblur();
        },
        // 失去焦点 持续聚焦这个会影响查询弹窗的操作，所有在第一次打开聚焦就好
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            that.$nextTick(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            });
        },
        inputDataChange() {
            let that = this;
            that.resetSearch();

            //扫码客户二维码很难扫出内容，现在通过订单号+'CUST'作为客户标识生成条形码，通过订单号得出客户Id
            that.scanData = that.scanData.trim();
            if (that.scanData.indexOf('XS') > -1 && that.scanData.indexOf('CUST') == -1) {
                if (that.scanData.length == 17) {
                    let order = that.tableData.findIndex(x=>x.OrderCode == that.scanData);
                    if(!that.firstScanOrder && order > -1){
                        that.aplayAudio(that.checkRepeatCodeAudio);
                        that.$util.warningMsg('已扫入重复单号【'+that.scanData+'】');
                        that.scanData = "";
                        return false;
                    }
                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosGet({
                            // url: '/api/RevenueManagement_H/GetCusConfirmOrderByScan',
                            url: '/api/RevenueManagement_H/GetCusConfirmOrderByScan_New',
                            data: { orderCode: that.scanData }
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                that.$util.warningMsg('未检测到相应的单据');
                                return;
                            } else {
                                that.tableData.push(data);
                            }
                            let list = that.tableData;
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                            that.tableData = list.reverse();
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else if (that.scanData.indexOf('XSTH') > -1 && that.scanData.length == 19) {

                    let order = that.tableData.findIndex(x=>x.OrderCode == that.scanData);
                    if(!that.firstScanOrder && order > -1){
                        that.aplayAudio(that.checkRepeatCodeAudio);
                        that.$util.warningMsg('已扫入重复单号【'+that.scanData+'】');
                        that.scanData = "";
                        return false;
                    }

                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosGet({
                            // url: '/api/RevenueManagement_H/GetCusConfirmOrderByScan',
                            url: '/api/RevenueManagement_H/GetCusConfirmOrderByScan_New',
                            data: { orderCode: that.scanData }
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                that.$util.warningMsg('未检测到相应的单据');
                                return;
                            } else {
                                that.tableData.push(data);
                            }
                            let list = that.tableData;
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            that.tableData = list.reverse();
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else {
                    that.$util.warningMsg('销售单号/退货单号长度不符合规则！');
                }
            } else if (that.scanData.length == 36 || that.scanData.indexOf('CUST') > -1) {
                //当前设定的日期时间
                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date1 = new Date(year1, month1, day1, 0);

                //前一天设定的日期时间
                let year2, month2, day2;
                d.setTime(d.getTime());
                [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date2 = new Date(year2, month2, day2, 0);

                if (that.isExObj('SubmitTime')) {
                    that.datetime3.push(date1);
                    that.datetime3.unshift(date2);

                    that.searchData.CStartDate = date2;
                    that.searchData.CEndDate = date1;
                } else if (that.isExObj('CreateTime')) {
                    that.datetime1.push(date1);
                    that.datetime1.unshift(date2);

                    that.searchData.StartDate = date2;
                    that.searchData.EndDate = date1;
                }

                that.searchData.CusId = that.scanData;
                that.tableData = [];
                that.searchParams = { ...that.searchData };
                that.$util
                    .axiosPost({
                        // url: '/api/RevenueManagement_H/GetCusOrdersConfirmList',
                        url: '/api/RevenueManagement_H/GetCusOrdersConfirmList_New',
                        data: that.searchData
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                             that.searchData.CusId='';
                            return;
                        }
                        that.tableData = data.DataList;
                        that.getOtherData();
                    });
            }
            that.scanData = '';
        },
        // 记录每行的key值,作用可以说是选中的不会清除，还有唯一性报错等问题
        getRowKeys(row) {
            return row.OrderId;
        },
        closeConfirm(args) {
            this.confirmVisible = false;
            if (args && args.length > 0) {
                let that = this;
                that.tableData.forEach(item => {
                    if (item.OrderId == that.currentRow.OrderId) {
                        item.IsCanStateBack = true;
                        item.ConfirmStateName = '已确认';
                        if (args[0]) {
                            item.PayTypeName = args[0].PayName;
                            item.Confirmer = args[0].UserName;
                            item.ConfirmTime = args[0].ConfirmTime;
                        }
                        if (args[1]) item.Paid = +args[1];
                        return;
                    }
                });
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack || (!row.IsDelivery && !row.IsAllNotOut)) return false;
            else return true;
        },
        handleBacthSubmit() {
            let that = this;
            if (!that.confirmFormData.PayType) {
                that.$util.warningMsg('请先选择支付方式，再进行批量确认提交操作');
                return;
            } else {
                let ind = that.payWayList.filter(f => f.Value === that.confirmFormData.PayType);
                if (ind && ind.length > 0) {
                    if (ind[0].IsSecSpecial) {
                        if (!that.confirmFormData.LogisticName) {
                            that.$util.warningMsg('支付方式为托收时，物流公司为必选项');
                            return;
                        }
                    }
                }
            }
            //过滤未出仓的订单
            let ids=that.idList.filter(x =>that.tableData.some(t =>t.IsDelivery&&t.OrderId==x));
             if(!(ids && ids.length > 0)){
                 that.$util.warningMsg('没有可确认的订单或者订单未完成出仓');
                 return;
            }
            
            that.$confirm('您确定要将选中数据进行批量确认吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.confirmOrder(ids);
                })
                .catch(() => {});
        },
        closeBacthConfirm() {
            this.dialogBacthVisible = false;
            this.confirmFormData = {
                OrderIds: [],
                PayType: '',
                LogisticId: '',
                LogisticName: ''
            };
        },
        // 打印预览
        print() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.tableData.length == 0) {
                this.$util.warningMsg('请选择单据');
                return;
            }
            this.printDialogVisible = true;
        },
        closePrintDialog() {
            this.printDialogVisible = false;
        },
        viewOrderDetail(orderType, orderId) {
            if (orderId) {
                this.idList = [];
                this.idList.push(orderId);
                if (orderType == 0) {
                    if (!this.askShowDisc) this.printOrderPreview = true;
                    else {
                        this.showDisc = true;
                        this.$confirm('是否打印显示优惠价？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '否',
                            type: 'warning'
                        })
                            .then(() => {
                                this.showDisc = true;
                                this.printOrderPreview = true;
                            })
                            .catch(() => {
                                this.showDisc = false;
                                this.printOrderPreview = true;
                            });
                    }
                } else if (orderType == 1) {
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(11).then(data => {
                if (data) {
                    Vue.component('printDeliveryConfirms', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printDeliveryConfirms', () => import('@/components/printModels/printHKDeliveryConfirms'));
                    that.isRegister = true;
                }
            });
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContentDC', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContentDC', () => import('@/components/printModels/printSales'));
                }
            });

            that.$util.getPrintComponents(4).then(data => {
                if (data) {
                    Vue.component('printReturnContentDC', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContentDC', () => import('@/components/printModels/printSaleReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        exportExcel() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请选择要导出的数据');
                return;
            }
            // let pts = '';
            // if (that.searchData.PayType.length > 0) {
            //     pts = that.searchData.PayType.join(',');
            // }
            that.$util.exportFile_post({
                // url: '/api/RevenueManagement_H/ExportSaleConfirms',
                url: '/api/RevenueManagement_H/ExportSaleConfirms_New',
                data: {
                    State: that.searchData.State,
                    // PayTypes: pts,
                    DeliveryState: that.searchData.DeliveryState,
                    SId: that.searchData.SId,
                    PayType: that.searchData.PayType,
                    Keyword: that.searchData.Keyword,
                    LogisName: that.searchData.LogisName,
                    OrderCode: that.searchData.OrderCode,
                    StartDate: that.searchData.StartDate,
                    EndDate: that.searchData.EndDate,
                    UStartDate: that.searchData.UStartDate,
                    UEndDate: that.searchData.UEndDate,
                    CStartDate: that.searchData.CStartDate,
                    CEndDate: that.searchData.CEndDate,
                    WStartDate: that.searchData.WStartDate,
                    WEndDate: that.searchData.WEndDate,
                    ConfirmerId: that.searchData.ConfirmerId,
                    SortProp: that.searchData.SortProp,
                    SortType: that.searchData.SortType,
                    OrderType: that.searchData.OrderType,
                    CusId: that.searchData.CusId,
                    WarehouseId: that.searchData.WarehouseId,
                    OrgIds: that.searchData.OrgIds
                }
            });
        },
        correctCost(item) {
            if (item) {
                this.correctItem = item;
                this.correctVisible = true;
            }
        },
        closeCorrectDialog(args) {
            this.correctVisible = false;
            let that = this;
            if (args && args.length > 0) {
                if (args[0]) {
                    that.tableData.forEach(item => {
                        if (item.OrderId == args[0].OrderId) {
                            item.OrderCost = args[0].TotalCost;
                            return;
                        }
                    });
                }
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length == 0) that.searchLogistic();
            }
        },
        searchLogistic(key) {
            if (![undefined].includes(key)) {
                this.lcForm.Page = 1;
                this.lcForm.stopLoad = false;
                this.lcForm.key = key;
                this.logisticsList = [];
            }
            if (this.lcForm.stopLoad) return;
            this.$util
                .searchLogistic(this.lcForm.key, this.lcForm.Page, this.lcForm.Limit)
                .then(res => {
                    let data = res;
                    if (!data) return;
                    this.lcForm.stopLoad = data.length < this.lcForm.Limit;
                    this.logisticsList = [...this.logisticsList, ...data];
                })
                .catch(() => {});
        },
        searchLcLoad() {
            this.lcForm.Page += 1;
            this.searchLogistic();
        },
        logisticChange(val) {
            if (!val) {
                this.confirmFormData.LogisticName = '';
            } else {
                let logist = this.logisticsList.find(e => e.EntpCusId == val);
                if (logist) {
                    this.confirmFormData.LogisticName = logist.EntpCusName;
                }
            }
        },
        //出库确认列表使用的物流查询方法
        lcsVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.lcsList.length == 0) that.searchlcs();
            }
        },
        searchlcs(key) {
            if (![undefined].includes(key)) {
                this.lcsForm.Page = 1;
                this.lcsForm.stopLoad = false;
                this.lcsForm.key = key;
                this.lcsList = [];
            }
            if (this.lcsForm.stopLoad) return;
            this.$util
                .searchLogistic(this.lcsForm.key, this.lcsForm.Page, this.lcsForm.Limit)
                .then(res => {
                    let data = res;
                    if (!data) return;
                    this.lcsForm.stopLoad = data.length < this.lcsForm.Limit;
                    this.lcsList = [...this.lcsList, ...data];
                })
                .catch(() => {});
        },
        searchLcsLoad() {
            this.lcsForm.Page += 1;
            this.searchlcs();
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        },
        lcsChange(val) {
            if (!val) {
                this.searchData.LogisName = '';
            } else {
                let logist = this.lcsList.find(e => e.EntpCusId == val);
                if (logist) {
                    this.searchData.LogisName = logist.EntpCusName;
                }
            }
        },
        // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 100);
            });
        },
        showLabelsData(item) {
            if (!this.labelVisible) {
                this.recData = { OrderId: item.OrderId, Type: item.OrderType };
                this.labelVisible = true;
            } else if (this.labelVisible) {
                this.$refs.orderGoodsLabels.updateTableData({ OrderId: item.OrderId, Type: item.OrderType });
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-dc-dialog,
#scan-dc-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    margin-bottom: 10px;
}
</style>
<style lang="less">
.row-warning {
    background-color: rgb(250, 250, 216) !important;
}
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
    }
}
#label-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
</style>
